import { useMutation, useQuery } from '@tanstack/react-query';
import { assessmentsData, getAssessmentData } from '../../../services/assessment';

export const useAssessment = (listId) => {
  const assessMutation = useMutation({
    mutationFn: () => assessmentsData(listId),
  });

  const isComplete = assessMutation.data?.detail === 'Assessment Complete!';

  const assessmentQuery = useQuery({
    queryKey: ['assessmentData', listId],
    queryFn: () => getAssessmentData(listId),
    enabled: !!listId && isComplete,
  });

  const trigger = () => assessMutation.mutate();

  return { assessMutation, assessmentQuery, isComplete, trigger };
};
